<template>
  <div class="fts-display">
    <template v-if="model">
      <!-- yes no -->
      <div
        class="fts-display-form-control yes-no-display"
        v-if="item.type === 1"
      >
        <font-awesome-icon
          class="success-theme"
          :icon="['fas', 'check']"
          fixed-width
          v-if="model === 'Yes'"
        />
      </div>
      <!-- module -->
      <div
        class="fts-display-form-control dropdown-display"
        v-else-if="item.type === 7"
      >
        <a
          class="locus-link"
          target="_blank"
          :href="locusURL"
          @click.prevent="openQuickView"
          v-if="locusURL && !editMode"
        >
          {{ model }}
        </a>
        <!-- default -->
        <template v-else>{{ model }}</template>
      </div>
      <!-- location -->
      <div
        class="fts-display-form-control location-display"
        v-else-if="item.type === 9"
      >
        <template v-if="model && model.lat && model.lng">
          <a
            target="_blank"
            :href="
              'http://www.google.com/maps/place/' + model.lat + ',' + model.lng
            "
            v-if="!editMode"
          >
            <font-awesome-icon :icon="['fas', 'map-marked-alt']" fixed-width />
          </a>
          <font-awesome-icon
            class="default-icon"
            :icon="['fas', 'map-marked-alt']"
            fixed-width
            v-else
          />
        </template>
        <div class="location-name">{{ model.placeName }}</div>
      </div>
      <!-- table -->
      <fts-table-edit-display
        :form-data="model"
        :item="item"
        :vectorId="vectorId"
        v-else-if="item.type === 14"
      />
      <!-- list -->
      <fts-list
        :form-data="formData"
        :item="item"
        :view="view"
        v-else-if="item.type === 15"
      />
      <!-- multiline text -->
      <div
        class="fts-display-form-control multi-text-display"
        ref="ftsDisplayTextArea"
        v-else-if="item.type === 16"
      >
        <span>{{ model }}</span>
      </div>
      <!-- image(s), file(s) -->
      <fts-file
        class="file-upload-display"
        :prefixURL="`${vectorId}-${item.id}`"
        :data="model"
        :file-type="fileType"
        downloadable
        v-else-if="fileType"
      />
      <!-- username, profile (module) -->
      <fts-profile
        :user-name="item.type === 19 ? model : userNameModel"
        profile-name-class="dropdown-user-display-name"
        class="fts-display-form-control dropdown-user-display"
        v-else-if="item.type === 19 || item.type === 20"
      >
        <template #profileName="{ userProfileUsername }">
          <!-- username -->
          <div v-if="item.type === 19">{{ userProfileUsername }}</div>
          <!-- profile -->
          <a
            class="locus-link"
            :href="locusURL"
            target="_blank"
            @click.prevent="openQuickView"
            v-else-if="locusURL && !editMode"
          >
            {{ model }}
          </a>
          <!-- default -->
          <div v-else>{{ model }}</div>
        </template>
      </fts-profile>
      <!-- content -->
      <div
        class="display-content"
        v-else-if="item.type === 22"
        v-html="model"
      ></div>
      <!-- context -->
      <div
        class="fts-display-form-control context-display"
        v-else-if="item.type === 24"
      >
        <div
          class="context-display-item"
          v-for="option in model"
          :key="option.id"
        >
          {{ option.name }}
        </div>
      </div>
      <!-- email -->
      <div
        class="fts-display-form-control contact-link-display"
        v-else-if="item.type === 25"
      >
        {{ model }}
        <a :href="'mailto:' + model">
          <font-awesome-icon :icon="['far', 'envelope']" />
        </a>
      </div>
      <!-- phone number -->
      <div
        class="fts-display-form-control contact-link-display"
        v-else-if="item.type === 26"
      >
        {{ model }}
        <a
          target="_blank"
          :href="'https://api.whatsapp.com/send?phone=' + model"
        >
          <font-awesome-icon :icon="['fab', 'whatsapp']" />
        </a>
      </div>
      <!-- select -->
      <div
        class="fts-display-form-control normal-display"
        v-else-if="item.type === 27 && !item.reference"
      >
        <div
          class="fts-display-form-tag"
          :style="{ 'background-color': getColor }"
        >
          {{ model }}
        </div>
      </div>
      <!-- signature -->
      <fts-file
        class="signature-display"
        :prefixURL="`${vectorId}-${item.id}`"
        :data="model"
        fileType="image"
        file-content-class="signature-display-content"
        :image-width="300"
        :image-height="150"
        image-contain
        downloadable
        v-else-if="item.type === 29"
      />
      <!-- link -->
      <div class="fts-display-form-control" v-else-if="item.type === 33">
        <!-- link:query -->
        <div
          class="fts-link-primary"
          @click="toggleQueryUrl"
          v-if="isQueryUrl"
        >
          {{ model.name }}
        </div>
        <!-- link:UNC -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="uNCFilePath"
          v-else-if="uNCFilePath"
        >
          {{ model.name }}
        </a>
        <!-- link:default -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="linkURL"
          v-else-if="linkURL"
        >
          {{ model.name }}
        </a>
        <!-- link:name -->
        <template v-else>{{ model.name }}</template>
      </div>
      <!-- default -->
      <div class="fts-display-form-control normal-display" v-else>
        {{ model }}
      </div>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import numeral from "numeral";

import commons from "../commons/commons";
import { uNCValidator } from "../commons/validator";

import FTSTableEditDisplay from "./FTSTableEditDisplay";
import FTSList from "./FTSList";
import FTSFile from "./file/FTSFile";
import FTSProfile from "./FTSProfile";

export default {
  props: {
    vectorId: [Number, String],
    formData: Object,
    item: Object,
    format: String,
    onExecute: Function,
    editMode: Boolean,
    view: Boolean,
  },
  components: {
    "fts-table-edit-display": FTSTableEditDisplay,
    "fts-list": FTSList,
    "fts-file": FTSFile,
    "fts-profile": FTSProfile,
  },
  methods: {
    clickLink() {
      this.onExecute(this.item, this.formData);
    },
    openQuickView() {
      window.eventBus.$emit("quickViewData", {
        id: commons.model(this.formData, this.item.fieldName, true),
      });
    },
    toggleQueryUrl() {
      try {
        const urlParams = new URLSearchParams(this.model.url);
        const params = Object.fromEntries(urlParams);
        if (params.d && params.id && params.v) {
          window.eventBus.$emit("showPDFDocument", {
            document: {id: params.d, typeId: 'pdf'},
            items: [{id: params.id}],
            moduleId: params.v
          });
        }
      } catch(err) {
        console.warn("Display:ToggleQueryUrl", err);
      }
    },
  },
  computed: {
    model() {
      const result = commons.model(this.formData, this.item.fieldName);
      if (result) {
        /* multiline text */
        if (this.item.type === 16) {
          this.$nextTick(() => {
            let ftsDisplayTextArea = this.$refs.ftsDisplayTextArea;
            if (ftsDisplayTextArea)
              ftsDisplayTextArea.style.marginTop =
                ftsDisplayTextArea.clientHeight > 32 ? "1px" : null;
          });
        }
        /* date */
        else if (this.item.type === 5) {
          if (this.item.predefinedFormatId)
            return luxon
              .fromISO(result)
              .toFormat(
                commons.dateFormatTranslate(this.item.predefinedFormatId)
              );
          else
            return luxon
              .fromISO(result)
              .toFormat(
                commons.dateFormatTranslate("DD")
              );
        }
        /* date time */
        else if (this.item.type === 6) {
          if (this.item.predefinedFormatId)
            return luxon
              .fromISO(result)
              .toFormat(
                commons.dateFormatTranslate(this.item.predefinedFormatId)
              );
          else
            return luxon
              .fromISO(result)
              .toFormat(
                commons.dateFormatTranslate("DD t")
              );
        }
        /* yes no */
        else if (this.item.type === 1) {
          return result ? "Yes" : "No";
        }
        /* number */
        else if (this.item.type === 3) {
          if (this.item.customFormat) {
            return numeral(result).format(this.item.customFormat);
          } else if (this.item.displayFormat) {
            return numeral(result).format(this.item.displayFormat);
          } else {
            const decimalPlaces = commons.isInteger(this.item.decimalPlaces) ? this.item.decimalPlaces : 2;
            return result.toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            });
          }
        }
        /* money */
        else if (this.item.type === 4) {
          return numeral(result).format("0,0.00");
        }
        /* display */
        else if (
          this.item.input == "display" &&
          Object.prototype.toString.call(result) === "[object Date]"
        ) {
          if (this.item.displayFormat)
            return moment(result).format(this.item.displayFormat);
          else return moment(result).format("ll");
        }
        /* location */
        else if (this.item.type === 9) {
          /* for old data */
          return {
            lat: result.lat ? result.lat : result.latitude,
            lng: result.lng ? result.lng : result.longitude,
            placeName: result.placeName,
          };
        }
        /* link */
        else if (this.item.type === 33) {
          if (result.constructor === String) {
            return {
              url: result,
              name: result,
            };
          } else if (result.constructor == Object) {
            return result.name === null || result.name === undefined ?
              {...result, name: '(undefined)'} : result;
          }

          return { name: 'invalid URL' };
        }
      } else if (this.item.type === 1 && result === false) {
        return "No";
      } else if (
        (this.item.type === 2 || this.item.type === 3) &&
        result === 0
      ) {
        return "0";
      } else if (this.item.type === 4 && result === 0) {
        return "0.00";
      } else if (this.item.type === 14) {
        return [];
      }
      /* default */
      return result;
    },
    userNameModel() {
      return commons.model(this.formData, `${this.item.fieldName}Username`);
    },
    fileType() {
      if (this.item.type === 10 || this.item.type === 11)
        return "image";
      else if (this.item.type === 12 || this.item.type === 13)
        return "file";
    },
    getColor() {
      return commons.selectOptionBackground({
        optionList: this.item.optionList,
        text: this.model,
      });
    },
    locusURL() {
      const locusId = commons.model(this.formData, this.item.fieldName, true);
      return locusId ? `/#/dashboard?id=${commons.encodeids(locusId)}` : null;
    },
    /* link */
    isQueryUrl() {
      return Boolean(
        this.model &&
        this.model.url &&
        this.model.url.startsWith("?")
      );
    },
    linkURL() {
      if (this.model && this.model.url)
        return this.model.url.toLowerCase().startsWith("http") ? this.model.url : `//${this.model.url}`
    },
    uNCFilePath() {
      if (this.model && this.model.url && uNCValidator(this.model.url)) {
        if (/^([a-zA-Z]\:\\|\\\\)/g.test(this.model.url))
          return `ist://${this.model.url}`;
        else
          return `file:///${this.model.url}`;
      }
    },
  },
  mounted() {
    if (this.item.fieldName && this.item.fieldName.indexOf(".") < 0) {
      if (this.formData[this.item.fieldName] === undefined) {
        Vue.set(this.formData, this.item.fieldName, null);
      }

      if (this.item.input == "dropDown" || this.item.input == "autoComplete") {
        if (this.formData[this.item.fieldName + "Id"] === undefined) {
          Vue.set(this.formData, this.item.fieldName + "Id", 0);
        }

        if (this.formData[this.item.fieldName + "Model"] === undefined) {
          Vue.set(this.formData, this.item.fieldName + "Model", null);
        }
      }
    } else if (this.item.fieldName) {
      var primer = this.formData;
      _.each(this.item.fieldName.split("."), function (field) {
        if (primer !== null) {
          if (primer[field] === undefined) {
            Vue.set(primer, field, null);
            primer[field] = null;
          } else {
            primer = primer[field];
          }
        }
      });
    }
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

@mixin border-transparent-x {
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}

.fts-display {
  min-height: $height;
  font-size: 0.75rem;
  font-family: $fontFamily;
  word-break: break-word;
  .display-link-decoration-none {
    color: $primaryColor;
    text-decoration: none;
  }
  .display-icon {
    color: var(--fts-gray-5);
  }
  .fts-display-form-tag {
    padding-left: 6px;
    padding-right: 6px;
    border-radius: 4px;
    color: #000;
  }
  .fts-display-form-control {
    display: flex;
    align-items: center;
    white-space: normal;
    &.normal-display {
      @include border-transparent-x;
    }
    &.yes-no-display {
      .success-theme {
        color: var(--fts-success);
      }
      .danger-theme {
        color: var(--fts-danger);
      }
    }
    &.dropdown-display {
      @include border-transparent-x;
      a {
        @extend .display-link-decoration-none;
      }
    }
    &.dropdown-user-display {
      align-items: flex-start;
      .dropdown-user-display-name {
        min-height: 20px;
        display: flex;
        align-items: center;
        a {
          @extend .display-link-decoration-none;
        }
      }
    }
    &.multi-text-display {
      @include border-transparent-x;
      span {
        white-space: pre-wrap;
      }
    }
    &.location-display {
      align-items: start;
      svg {
        margin-top: 3px;
        color: $primaryColor;
      }
      a {
        @extend .display-link-decoration-none;
        display: inline-flex;
      }
      .location-name {
        margin-left: 0.575rem;
        font-size: 0.75rem;
      }
    }
    &.contact-link-display {
      @include border-transparent-x;
      &:hover {
        > a {
          visibility: visible;
        }
      }
      > a {
        visibility: hidden;
        display: flex;
        margin-left: 0.375rem;
        &:hover {
          svg {
            color: $primaryColor;
          }
        }
        svg {
          font-size: 1.25rem;
          color: var(--fts-gray-5);
        }
      }
    }
  }
  .signature-display {
    .signature-display-content {
      border: 1px solid var(--fts-form-control-border);
    }
  }
  .context-display {
    flex-direction: column;
    align-items: flex-start;
    .context-display-item {
      &:not(:last-child) {
        margin-bottom: 0.375rem;
      }
    }
  }
  svg {
    font-size: 0.875rem;
  }
}
</style>

